export default {
  name: "remove",
  box: 20,
  svg: `<path
  d="M16.517 5.96545V17.4482C16.517 17.8598 16.3535 18.2544 16.0625 18.5454C15.7715 18.8365 15.3768 18.9999 14.9653 18.9999H4.41354C4.002 18.9999 3.60731 18.8365 3.31631 18.5454C3.0253 18.2544 2.86182 17.8598 2.86182 17.4482V5.96545"
  stroke="#0F0F0F"
  stroke-width="2"
  stroke-miterlimit="10"
  stroke-linecap="square"
/>
<path
  d="M9.68994 8.44824V15.2758"
  stroke="#0F0F0F"
  stroke-width="2"
  stroke-miterlimit="10"
  stroke-linecap="square"
/>
<path
  d="M6.58643 8.44824V15.2758"
  stroke="#0F0F0F"
  stroke-width="2"
  stroke-miterlimit="10"
  stroke-linecap="square"
/>
<path
  d="M12.793 8.44824V15.2758"
  stroke="#0F0F0F"
  stroke-width="2"
  stroke-miterlimit="10"
  stroke-linecap="square"
/>
<path
  d="M6.58643 4.10345V1H12.7933V4.10345"
  stroke="#0F0F0F"
  stroke-width="2"
  stroke-miterlimit="10"
  stroke-linecap="square"
/>
<path
  d="M18.3793 4.10339H1"
  stroke="#0F0F0F"
  stroke-width="2"
  stroke-miterlimit="10"
  stroke-linecap="square"
/>`,
};
